import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CompanyDetailMaster } from '../model/CompanyDetailMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  companyDetailMaster:CompanyDetailMaster = new CompanyDetailMaster();

  constructor(private authService:AuthService,private mainService:MainserviceService) { }

  ngOnInit() {
    this.getCompanyDetail();
  }


  getCompanyDetail(): any {
    // this.spinnerService.show();
  
    this.mainService.getCompanyDetail(new CompanyDetailMaster()).subscribe(
      data => {
        this.companyDetailMaster = data;
        // this.spinnerService.hide();
      },
      error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
         //   this.spinnerService.hide();
            let data = JSON.parse(jsonString);
            this.companyDetailMaster = data;
          } else {
            this.authService.showMessage('error','Something went wrong', '');
          //  this.spinnerService.hide();
          }
          // this.spinnerService.hide();
        }
      }
    );
  }

}
